import { useAuth } from './useAuth';

export function AccessDenied() {
  const { logout, user } = useAuth();

  const handleSignOut = () => {
    logout().catch((error) => {
      console.error('Logout error:', error);
    });
  };

  const userEmail = user?.profile?.email;

  return (
    <div className="access-denied">
      <div className="access-denied__content">
        <div className="access-denied__icon">
          <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
            <circle cx="12" cy="12" r="10" />
            <line x1="4.93" y1="4.93" x2="19.07" y2="19.07" />
          </svg>
        </div>
        <h1 className="access-denied__title">Access Denied</h1>
        <p className="access-denied__message">
          You don't have permission to access this application.
        </p>
        {userEmail && (
          <p className="access-denied__email">
            Signed in as <strong>{userEmail}</strong>
          </p>
        )}
        <p className="access-denied__contact">
          Please contact the <strong>Toptracer Go team</strong> to request access.
        </p>
        <button className="access-denied__button" onClick={handleSignOut}>
          Sign out
        </button>
      </div>
    </div>
  );
}
